import React, { Component } from 'react';
import {
  Switch,
  Route,
  HashRouter
} from "react-router-dom";
import EnrolmentForm from "./Component/RegForm/EnrolmentForm";
import AdmissionSuccess from "./Component/RegForm/AdmissionSuccess";
import AdmissionStatus from "./Component/RegForm/AdmissionStatus";
import Context from './Context';
import axios from "./Component/axiosApis"
class App extends Component {
  router
  constructor(props) {
    super(props);
    this.state = {
      val: [],
      head_status: '',
    };
  }

  updateValue = (key, val) => {
    axios
      .get(`${val}`)
      .then(result => {
        var val = result.data;
        this.setState({
          val: val
        })
      }).catch(err => {
      })

  }

  render() {
    return (
      <HashRouter>
        <Switch>
          {/* <Route path="/" component={Cmp} /> */}
          <Route exact path="/" component={EnrolmentForm} />
          <Route exact path="/success" component={AdmissionSuccess} />
          <Route exact path="/status/" component={AdmissionStatus} />


        </Switch>
        {/* <Context.Provider value={{ state: this.state, updateValue: this.updateValue }}>
          <Switch>
            <Route exact path="/" component={EnrolmentForm} />
            <Route exact path="/success" component={AdmissionSuccess} />
            <Route exact path="/status/" component={AdmissionStatus} />
          </Switch>
        </Context.Provider> */}
      </HashRouter>
    );
  }
}

export default App;


const Cmp = () => {
  return (
    <h5>******</h5>
  )
}
